import React from 'react'

const NoResults = ({message}) => {
    return (
        <p className="lead text-center">{message ? message : "No results found."}</p>
    )
}

export default NoResults